module.exports = __webpack_public_path__ + "assets/Crowding.7e267f7bdc988efc2cd8f4a36cd804ec.svg";